import { render, staticRenderFns } from "./WatchStatusBadge.vue?vue&type=template&id=3e7a8c99&scoped=true"
import script from "./WatchStatusBadge.vue?vue&type=script&lang=js"
export * from "./WatchStatusBadge.vue?vue&type=script&lang=js"
import style0 from "./WatchStatusBadge.vue?vue&type=style&index=0&id=3e7a8c99&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e7a8c99",
  null
  
)

export default component.exports